
import axios from "axios"
import { WC_API_HEADER_KEY, WC_API_URL } from "../../../config/config"

export const SupportTicketCreateAPI = async (data) => {
   try {
     const res = await axios.post(`${WC_API_URL}/supportTickets`,
      data,
      {
         headers:{
            'x-internal-key' : WC_API_HEADER_KEY
         }
      }
     )
     return {success:true,res}
   } catch (error) {
      return {
            success:false,
            message:error?.response?.data?.message,
            error
        }
   }
}

export const SupportTicketGetAPI = async (id) => {
   try {
     const res = await axios.get(`${WC_API_URL}/supportTickets/byrequesterid?requesterId=${id}`,
      {
         headers:{
            'x-internal-key' : WC_API_HEADER_KEY
         }
      }
     )
     return {success:true,res}
   } catch (error) {
      return {
            success:false,
            message:error?.response?.data?.message,
            error
        }
   }
}